module.exports = __webpack_public_path__ + "img/outcome_not_automated.261d7517.svg";